export function PageHeader({ title, sub, actions, testid }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-5" data-testid={testid}>
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl tracking-tight font-bold">{title}</h1>
        {sub && <p className="text-sm text-muted-foreground mt-1">{sub}</p>}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}
